import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import CartItem from "../../sections/cart-item";
import Icon from "../../elements/icon";
import "./style.scss";
import { AnimatePresence, motion } from "framer-motion";
import { alertWindowAnimations, childAnimations } from "./animations";
import { showCartAlert, hideCartAlert } from "../../redux/actions/actions";
import { selectShowCartAlert, selectCartAlertItems, selectSessionId } from "../../selectors/application";
import { getCart } from "../../services/cartService";
import useScrollListener from "../../hooks/useScrollListener.js";
import classNames from "classnames";

const AlertWindow = ({ heading, cartPageLink, alertItems = [], numCartItems, setItems, hideCartAlert, match, noHeader }) => {
  const [items] = useState([...alertItems]);
  const [timer, setTimer] = useState();

  const cartIcon =
    '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M17,18A2,2 0 0,1 19,20A2,2 0 0,1 17,22C15.89,22 15,21.1 15,20C15,18.89 15.89,18 17,18M1,2H4.27L5.21,4H20A1,1 0 0,1 21,5C21,5.17 20.95,5.34 20.88,5.5L17.3,11.97C16.96,12.58 16.3,13 15.55,13H8.1L7.2,14.63L7.17,14.75A0.25,0.25 0 0,0 7.42,15H19V17H7C5.89,17 5,16.1 5,15C5,14.65 5.09,14.32 5.24,14.04L6.6,11.59L3,4H1V2M7,18A2,2 0 0,1 9,20A2,2 0 0,1 7,22C5.89,22 5,21.1 5,20C5,18.89 5.89,18 7,18M16,11L18.78,6H6.14L8.5,11H16Z" /></svg>';

  useEffect(() => {
    const _timer = setTimeout(() => {
      if (items.length) {
        setItems(items.splice(1, items.length));
        hideCartAlert();
      }
    }, 4000);
    setTimer(_timer);
    return () => clearTimeout(timer);
  }, [items]);

  return (
    <div className={classNames("cart-alert-window", { "no-header": noHeader })}>
      <motion.div className="content" variants={alertWindowAnimations} initial="exit" animate="enter" exit="exit">
        <span className="title-bar-container">
          <h4 className="type-h4">{heading}</h4>
          <div className="item-count-container">
            <Icon svg={cartIcon} />
            <span className="item-count">{`(${numCartItems})`}</span>
          </div>
        </span>
        <ul className="item-container">
          {items.map((item, index) => {
            return (
              <li id={index} key={index}>
                <motion.div className="cart-item-animation" variants={childAnimations} exit="exit">
                  <CartItem {...{ ...item, match: match, link: { url: cartPageLink?.href } }} />
                </motion.div>
              </li>
            );
          })}
        </ul>
      </motion.div>
    </div>
  );
};

const CartAlert = ({ fields, rendering, user, lang, isCartAlertVisible, showCartAlert, hideCartAlert, alertItems, sessionId, match }) => {
  const { title, cartPageLink } = fields;
  const [items, setItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);

  const getCartTotalCartItems = async () => {
    let currentShoppingCart = await getCart(lang);
    let total = 0;
    if (currentShoppingCart.obj.skuList !== null) {
      currentShoppingCart.obj.skuList.forEach(item => {
        total = total + item.skuCount;
      });
    }
    setTotalItems(total);
    setItems(oldItems => [...alertItems]);
  };

  const { scrollDirection } = useScrollListener();

  const headerIsHidden = () => {
    let el = document.getElementsByClassName("header-container")[0];

    return el?.classList?.contains("hide");
  };

  useEffect(() => {
    // to avoid feeling of double alert
    // only show cart alert on the page it was triggered from
    if ( alertItems && window.location.href === alertItems[0]?.pageTriggerdForm) {
      getCartTotalCartItems();
    }
  }, [alertItems, showCartAlert]);

  return (
    <AnimatePresence>
      {isCartAlertVisible && items.length > 0 && (
        <AlertWindow heading={title.value} cartPageLink={cartPageLink?.value} alertItems={items} numCartItems={totalItems} setItems={setItems} hideCartAlert={hideCartAlert} match={match} noHeader={scrollDirection === "down" || (scrollDirection === null && headerIsHidden())} />
      )}
    </AnimatePresence>
  );
};

CartAlert.propTypes = {
  heading: PropTypes.string,
  alertItems: PropTypes.array,
  numCartItems: PropTypes.number
};
const mapStateToProps = state => ({
  isCartAlertVisible: selectShowCartAlert(state),
  alertItems: selectCartAlertItems(state),
  sessionId: selectSessionId(state)
});
const mapDispatchToProps = dispatch => ({
  showCartAlert: () => dispatch(showCartAlert),
  hideCartAlert: () => dispatch(hideCartAlert()),
  dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(CartAlert);
